var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstimatesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H19V19.5C19 20.3284 18.3284 21 17.5 21H6.5C5.67157 21 5 20.3284 5 19.5V9Z",
    fill: "#C34BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H19V4.5C19 3.67157 18.3284 3 17.5 3H6.5C5.67157 3 5 3.67157 5 4.5V8Z",
    fill: "#7D01BA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#EBC2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#EBC2FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#EBC2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#EBC2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimatesActive);
export default __webpack_public_path__ + "static/media/estimates-active.7cbbb61a9f0cb9cf120f37fcb940bfd8.svg";
export { ForwardRef as ReactComponent };